import { useQuery } from '@tanstack/react-query';
import { awaitJSON, fetchCometSelfInvoke, SlidesLambdaFetch } from '../../utils/fetch-utils';

export interface Blueprint {
  id: number;
  presentation_id: string;
  channel: string;
  name: string;
  description: string;
}

interface AddBlueprintPayload {
  presentationId: string;
  channel: string;
  name: string;
  description: string;
}

interface EditBlueprintPayload {
  blueprintId: number;
  name: string;
  description: string;
}

const loadBlueprints = async (): Promise<Blueprint[]> => {
  const res = await SlidesLambdaFetch('/getBlueprints');
  return awaitJSON<Blueprint[]>(res);
};

export const BLUEPRINTS_QUERY_KEY = ['slideGeneratorBlueprints'];

export const useBlueprints = (): ReturnType<typeof useQuery<Blueprint[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: BLUEPRINTS_QUERY_KEY,
    queryFn: loadBlueprints
  });

export const addBlueprint = async (payload: AddBlueprintPayload): Promise<void> => {
  await SlidesLambdaFetch('/addBlueprint', { method: 'POST', body: payload });
};

export const editBlueprint = async (payload: EditBlueprintPayload): Promise<void> => {
  await SlidesLambdaFetch('/editBlueprint', { method: 'POST', body: payload });
};

export const syncBlueprint = async (presentationId: string, accessToken: string): Promise<void> => {
  await fetchCometSelfInvoke(
    SlidesLambdaFetch,
    '/syncBlueprint',
    { presentationId, accessToken },
    { noTimeout: true }
  );
};
